<template>
  <div class="search_bar">
    <img
      v-if="showBack"
      src="@/assets/common/icon_back@2x.png"
      alt=""
      class="search_go_back"
      @click.stop="back"
    />
    <div class="search">
      <slot />
    </div>
    <div v-if="rightName" class="cancel">{{ rightName }}</div>
  </div>
</template>

<script>
export default {
  props: {
    rightName: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    back() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="less" scoped>
.search_bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  z-index: 1999;
  background: #f6f7f8;
  display: flex;
  flex-direction: row;
  padding: 0 12px;
  .search_go_back {
    width: 24px;
    cursor: pointer;
    margin: auto 12px auto 0;
  }
}
.search {
  margin: auto 0;
  width: 100%;
}
.cancel {
  margin: auto 0 auto 24px;
  font-size: 14px;
  font-weight: 400;
  color: #222;
  line-height: 48px;
}
</style>
